import * as React from 'react';
import * as uniqid from 'uniqid';

interface IRadioProps {
  type?: string;
  fieldName: string;
  label: string | JSX.Element;
  value?: any;
  onChange: (e: any) => void;
  checked?: boolean;
  readOnly?: boolean;
}

export default (props: IRadioProps) => {

  const className = 'radio';
  const Id = uniqid('radio-');
  const { fieldName, label, value, type, onChange, checked, readOnly } = props;

  return (
      <div className={`${className}${type ? ' ' + className + '--' + type : ''}${readOnly ? ' disabled' : ''}`}>
        <label className="radio__label" htmlFor={Id}>
          <input
            className="radio__input"
            id={Id}
            name={fieldName}
            value={value}
            checked={checked}
            type="radio"
            readOnly={readOnly}
            onChange={(e: any) => readOnly !== true && onChange(e)}
          />
          <div className={`radio__checkmark${readOnly ? ' disabled' : ''}`} />
          <span className="radio__labelText">{label}</span>
        </label>
      </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/FormGenerator/Form/components/Radio.tsx